import { loadScript } from './helpers';

export async function loadRecaptchaScript() {
  await loadScript(`//www.google.com/recaptcha/api.js?render=${env.RECAPTCHA_V3_PUBLIC_KEY}`);
  return new Promise<void>((resolve) => {
    grecaptcha.ready(() => {
      resolve();
    });
  });
}

export async function validateV3() {
  return new Promise<string>((resolve) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(String(env.RECAPTCHA_V3_PUBLIC_KEY), { action: 'submit_claim' }).then((token) => {
        resolve(token);
      });
    });
  });
}

export async function resetReCaptcha(widgetId?: number) {
  return new Promise<void>((resolve) => {
    grecaptcha.ready(() => {
      grecaptcha.reset(widgetId);
      resolve();
    });
  });
}

export const isRecaptchaAvailable = env.RECAPTCHA_V3_PUBLIC_KEY;
